import { Routes,Route  } from 'react-router';
import './App.css';
import Home from './components/Home';
import Nav from './components/Nav';
import Showroom from './pages/Showroom';
import CrateLifter from './pages/CrateLifter';
import FlowRacks from './pages/FlowRacks';
import Karakuri from './pages/Karakuri';
import Workstations from './pages/Workstations';

function App() {
  return (
    <div className="App">
      <Nav/>
      <Routes>
         <Route path='/' element={<Home/>}/>
         <Route path='/pocetna' element={<Home/>}/>
         <Route path='/sr/pocetna' element={<Home/>}/>
         <Route path='/showroom' element={<Showroom/>}/>
         <Route path='/cratelifter' element={<CrateLifter/>}/>
         <Route path='/flowracks' element={<FlowRacks/>}/>
         <Route path='/karakuri' element={<Karakuri/>}/>
         <Route path='/workstations' element={<Workstations/>}/>
      </Routes>
    </div>
  );
}

export default App;
